module.exports = __webpack_public_path__ + "static/img/about2.62644f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about2.png
// module id = D/cK
// module chunks = 0